export default __webpack_public_path__ + "static/media/500_tock.9f88d130.svg";